// extracted by mini-css-extract-plugin
module.exports = {"confirm":"confirm-iAQly","apply":"apply-XS9uD","cancel":"cancel-GOoxx"};